module.exports = __webpack_public_path__ + "img/lock.aee5270d.svg";